/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ContactDetailType = {
    Email: 'Email',
    Phone: 'Phone'
} as const;
export type ContactDetailType = typeof ContactDetailType[keyof typeof ContactDetailType];


export function instanceOfContactDetailType(value: any): boolean {
    for (const key in ContactDetailType) {
        if (Object.prototype.hasOwnProperty.call(ContactDetailType, key)) {
            if (ContactDetailType[key as keyof typeof ContactDetailType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ContactDetailTypeFromJSON(json: any): ContactDetailType {
    return ContactDetailTypeFromJSONTyped(json, false);
}

export function ContactDetailTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDetailType {
    return json as ContactDetailType;
}

export function ContactDetailTypeToJSON(value?: ContactDetailType | null): any {
    return value as any;
}

export function ContactDetailTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ContactDetailType {
    return value as ContactDetailType;
}

